import { css, makeStyles } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  containerBox: theme => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    span {
      font-weight: ${theme.fontWeights.bold};
    }
  `,

  submitButton: theme => css`
    margin-top: ${theme.spacing.md};
    margin-bottom: ${theme.spacing.xxs};
  `,
})

export { useStyles }
